// extracted by mini-css-extract-plugin
export default {"subRow":"dZsSWDN4AUoVRI8OMyGf","waId":"oZLcv__EsERo4SfWKcYw","expiredIndicator":"CjcGOrp0GHaKjlu1qthm","assigneeActions":"pokxTEmd_ZBFvf_2geSW"};